// Mock data for Photography Portfolio

export const portfolioImages = {
  galleryWork: [
    {
      id: 1,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/kwvxwbpe_86F6F6CD-6476-40AF-92C1-E41D19C3C665%202.JPG',
      title: 'Wild Horses',
      category: 'Gallery Work',
      featured: true
    },
    {
      id: 2,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/j9yyrua5_IMG_4324_VSCO%202.JPG',
      title: 'Mountain Waterfall',
      category: 'Gallery Work',
      featured: true
    },
    {
      id: 3,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/ljlnkfbp_IMG_4470_VSCO%202.JPG',
      title: 'Sunflowers at Sunset',
      category: 'Gallery Work',
      featured: true
    },
    {
      id: 4,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/vqh83qrp_14A7AD68-2181-4243-A2DB-039DBB5AD939.JPG',
      title: 'Moonlit Dock',
      category: 'Gallery Work',
      featured: true
    },
    {
      id: 5,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/ac4mb7o6_DSC_0387_VSCO%204.JPG',
      title: 'Cherry Blossoms',
      category: 'Gallery Work',
      featured: true
    },
    {
      id: 6,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/k215wqtu_DSC_0347_VSCO.JPG',
      title: 'Clock Tower Mountains',
      category: 'Gallery Work',
      featured: true
    },
    {
      id: 7,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/9udf8s8c_IMG_1390_VSCO%202.JPG',
      title: 'Golden Gate Bridge',
      category: 'Gallery Work',
      featured: false
    },
    {
      id: 8,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/msn4orps_IMG_4047_VSCO_VSCO%202.JPG',
      title: 'Urban Architecture',
      category: 'Gallery Work',
      featured: false
    }
  ],
  weddingEngagement: [
    {
      id: 1,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/pgtmpu42_DSC_0828.JPG',
      title: 'Tropical Sunset Kiss',
      category: 'Wedding & Engagement',
      featured: true
    },
    {
      id: 2,
      url: 'https://customer-assets-v7afamib.emergentagent.net/job_oahu-photo-book/artifacts/gief3dpc_DSC_0831.webp',
      title: 'Sunset Beach Stroll',
      category: 'Wedding & Engagement',
      featured: true
    },
    {
      id: 3,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/v46o9wbk_DSC_0771%202.JPG',
      title: 'Joyful Engagement',
      category: 'Wedding & Engagement',
      featured: true
    },
    {
      id: 4,
      url: 'https://customer-assets-v7afamib.emergentagent.net/job_oahu-photo-book/artifacts/v39mm4v7_DSC_0155.webp',
      title: 'Golden Hour Proposal',
      category: 'Wedding & Engagement',
      featured: true
    },
    {
      id: 5,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/fcyz2pso_DSC_0481_VSCO.JPG',
      title: 'Ocean Kiss',
      category: 'Wedding & Engagement',
      featured: true
    },
    {
      id: 6,
      url: 'https://customer-assets-v7afamib.emergentagent.net/job_oahu-photo-book/artifacts/max9fzeh_DSC_0215.webp',
      title: 'The Ring Reveal',
      category: 'Wedding & Engagement',
      featured: true
    },
    {
      id: 7,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/un0qi4lr_DSC_0133.JPG',
      title: 'Sunset Serenity',
      category: 'Wedding & Engagement',
      featured: true
    },
    {
      id: 8,
      url: 'https://customer-assets-v7afamib.emergentagent.net/job_oahu-photo-book/artifacts/zklpq98u_DSC_0668.webp',
      title: 'Beach Proposal Moment',
      category: 'Wedding & Engagement',
      featured: true
    },
    {
      id: 9,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/2hl5vog5_DSC_0703.JPG',
      title: 'Dancing at Golden Hour',
      category: 'Wedding & Engagement',
      featured: true
    },
    {
      id: 10,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/efa1vfw7_DSC_0577.JPG',
      title: 'Beach Wedding Bliss',
      category: 'Wedding & Engagement',
      featured: true
    },
    {
      id: 11,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/vetp6wiq_DSC_1052.JPG',
      title: 'Palm Paradise',
      category: 'Wedding & Engagement',
      featured: true
    },
    {
      id: 12,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/2wqkz04v_8A2198E1-C63D-49B7-936E-94165BFF4681.JPG',
      title: 'Silhouette Romance',
      category: 'Wedding & Engagement',
      featured: true
    },
    {
      id: 13,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/wh189wbh_DSC_0467.JPG',
      title: 'Lei Ceremony',
      category: 'Wedding & Engagement',
      featured: false
    },
    {
      id: 14,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/pr7ro84x_80DD6FA2-7F8A-4D4F-94D2-984F1FD693A8.JPG',
      title: 'Golden Hour Engagement',
      category: 'Wedding & Engagement',
      featured: false
    },
    {
      id: 15,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/d85azz49_074E242B-578B-4A03-9F91-6BDF0ADD6D02.JPG',
      title: 'Beach Paradise',
      category: 'Wedding & Engagement',
      featured: false
    },
    {
      id: 16,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/qg4im01p_DSC_0389.JPG',
      title: 'Sunset Kiss',
      category: 'Wedding & Engagement',
      featured: false
    },
    {
      id: 17,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/i40v7a93_DSC_0555.JPG',
      title: 'Ocean Romance',
      category: 'Wedding & Engagement',
      featured: false
    },
    {
      id: 18,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/a4id2dlm_DSC_0879%202.JPG',
      title: 'Island Love',
      category: 'Wedding & Engagement',
      featured: false
    }
  ],
  familyVacation: [
    {
      id: 1,
      url: 'https://customer-assets-v7afamib.emergentagent.net/job_oahu-photo-book/artifacts/ec5id66j_DSC_0006.webp',
      title: 'Sweet Family Moment',
      category: 'Family Vacation',
      featured: true
    },
    {
      id: 2,
      url: 'https://customer-assets-v7afamib.emergentagent.net/job_oahu-photo-book/artifacts/f4g3jadb_DSC_0887.webp',
      title: 'Tropical Garden Family',
      category: 'Family Vacation',
      featured: true
    },
    {
      id: 3,
      url: 'https://customer-assets-v7afamib.emergentagent.net/job_oahu-photo-book/artifacts/nc0uewsm_DSC_1175.webp',
      title: 'Beach Family Sunset',
      category: 'Family Vacation',
      featured: true
    },
    {
      id: 4,
      url: 'https://customer-assets-v7afamib.emergentagent.net/job_oahu-photo-book/artifacts/j8ghnk8g_DSC_0334.webp',
      title: 'Palm Tree Family Portrait',
      category: 'Family Vacation',
      featured: true
    },
    {
      id: 5,
      url: 'https://customer-assets-v7afamib.emergentagent.net/job_oahu-photo-book/artifacts/shm23xac_DSC_0559.webp',
      title: 'Tropical Family Photo',
      category: 'Family Vacation',
      featured: true
    },
    {
      id: 6,
      url: 'https://customer-assets-v7afamib.emergentagent.net/job_oahu-photo-book/artifacts/6udfh3oc_DSC_0243.webp',
      title: 'Large Family Gathering',
      category: 'Family Vacation',
      featured: true
    },
    {
      id: 7,
      url: 'https://customer-assets-v7afamib.emergentagent.net/job_oahu-photo-book/artifacts/4eugxb9z_DSC_0060%203.webp',
      title: 'Family Beach Fun',
      category: 'Family Vacation',
      featured: true
    },
    {
      id: 8,
      url: 'https://customer-assets-v7afamib.emergentagent.net/job_oahu-photo-book/artifacts/a7y73m2l_DSC_0417.webp',
      title: 'Family Beach Swing',
      category: 'Family Vacation',
      featured: true
    },
    {
      id: 9,
      url: 'https://customer-assets-v7afamib.emergentagent.net/job_oahu-photo-book/artifacts/zxq8tfix_DSC_0529.webp',
      title: 'Sunset Family Love',
      category: 'Family Vacation',
      featured: true
    },
    {
      id: 10,
      url: 'https://customer-assets-v7afamib.emergentagent.net/job_oahu-photo-book/artifacts/ozcwstws_A9638FE9-4258-4E56-98C2-5A2F31B7922D.webp',
      title: 'Harbor Family Portrait',
      category: 'Family Vacation',
      featured: true
    },
    {
      id: 11,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/uruhcnxw_4FF5E656-0927-41D7-99E3-9BB07823242A.JPG',
      title: 'Family Sunset Portrait',
      category: 'Family Vacation',
      featured: false
    },
    {
      id: 12,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/o4841h4b_DSC_0092.JPG',
      title: 'Dad with Twins',
      category: 'Family Vacation',
      featured: false
    },
    {
      id: 13,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/1bqtdasj_DSC_0186.JPG',
      title: 'Tropical Family',
      category: 'Family Vacation',
      featured: false
    },
    {
      id: 14,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/q3zw8mwz_DSC_0916.JPG',
      title: 'Golden Hour Family',
      category: 'Family Vacation',
      featured: false
    },
    {
      id: 15,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/6a3vrl7g_DSC_1660.JPG',
      title: 'Pink Sunset Family',
      category: 'Family Vacation',
      featured: false
    },
    {
      id: 16,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/djbqixr0_DSC_1983.JPG',
      title: 'Beach Family Portrait',
      category: 'Family Vacation',
      featured: false
    },
    {
      id: 17,
      url: 'https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/bmdv4qwp_DSC_0919.JPG',
      title: 'White Shirts Family',
      category: 'Family Vacation',
      featured: false
    },
    {
      id: 18,
      url: 'https://customer-assets-v7afamib.emergentagent.net/job_oahu-photo-book/artifacts/9ggob41e_DSC_0268.webp',
      title: 'Palm Tree Family Portrait',
      category: 'Family Vacation',
      featured: false
    }
  ]
};

export const services = [
  {
    id: 1,
    title: 'Wedding Photography',
    description: 'Capture your special day with stunning beach wedding photography. Full day coverage with unlimited photos.',
    duration: '4 hours',
    icon: 'Heart'
  },
  {
    id: 2,
    title: 'Engagement Sessions',
    description: 'Beautiful engagement photos on Oahu\'s most scenic beaches. Perfect for save-the-date cards.',
    duration: '1 hour',
    icon: 'Users'
  },
  {
    id: 3,
    title: 'Family Portraits',
    description: 'Create lasting memories with professional family beach portraits. Perfect for vacation keepsakes.',
    duration: '2 hours',
    icon: 'Camera'
  },
  {
    id: 4,
    title: 'Gallery & Artistic Shoots',
    description: 'Creative photography sessions showcasing Oahu\'s natural beauty. Ideal for portfolio building.',
    duration: '30min to 2 hours',
    icon: 'Image'
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: 'Mini',
    price: 200,
    duration: '25 min',
    features: [
      '25 min beach session',
      '30 edited high-res photos',
      'Google Drive link to all pictures taken during session',
      'Personal usage rights',
      '1 location'
    ],
    popular: true
  },
  {
    id: 2,
    name: 'Essential',
    price: 300,
    duration: '45 min',
    features: [
      '45 min beach session',
      '40 edited high-res photos',
      'Google Drive link to all pictures taken on session',
      'Personal usage rights',
      '1 location'
    ],
    popular: false
  },
  {
    id: 3,
    name: 'Premium',
    price: 425,
    duration: '1 hour',
    features: [
      '1 hour beach session',
      '50 edited high-res photos',
      'Google Drive link to all pictures taken on session',
      'Personal usage rights',
      'Drone footage included'
    ],
    popular: false
  },
  {
    id: 4,
    name: 'Ultimate',
    price: 850,
    duration: '3 hours',
    features: [
      '3 hour beach session',
      '100+ edited high-res photos',
      'Google Drive link to all pictures taken',
      'Full commercial rights',
      '3 locations',
      'Drone footage & video',
      'Engagement session included'
    ],
    popular: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah & Michael',
    service: 'Wedding Photography',
    text: 'Our beach wedding photos turned out absolutely magical! Every moment was captured beautifully.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop'
  },
  {
    id: 2,
    name: 'The Johnson Family',
    service: 'Family Portraits',
    text: 'Perfect vacation photos! The kids had so much fun and the photos are stunning. Will book again!',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop'
  },
  {
    id: 3,
    name: 'Emma & David',
    service: 'Engagement Session',
    text: 'Our engagement photos exceeded all expectations. The sunset shots are absolutely breathtaking!',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop'
  }
];

export const socialLinks = {
  instagram: 'https://instagram.com/kawikamoments'
};

export const aboutData = {
  title: 'Capturing Oahu\'s Beauty',
  description: 'Aloha, my name is David (Kawika) I specialize in beach weddings, family portraits, and artistic photography. With over 5 years of experience capturing moments on Oahu\'s stunning beaches, I bring passion, creativity, and technical expertise to every shoot.',
  highlights: [
    'Over 300 weddings photographed',
    'Featured in Hawaii Wedding Magazine',
    'Certified drone pilot',
    'Local knowledge of best beach locations'
  ]
};
